import developmentSteamJacuzzi from "../abis/development/pools/steamJacuzzi";

const host = "https://bscscan.com/address";

export default [
  {
    title: "Steam Jacuzzi",
    contractAddress: "0x784576a5de4c23a45a6da5e40ae1cdf4b9bd71ab",
    minApr: 159,
    abi: developmentSteamJacuzzi.abi,
    url: `${host}/0x784576a5de4c23a45a6da5e40ae1cdf4b9bd71ab`,
  },
];
